import { render, staticRenderFns } from "./Q15.vue?vue&type=template&id=157db4bc&"
import script from "./Q15.vue?vue&type=script&lang=ts&"
export * from "./Q15.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports